<template>
  <v-col
    cols="12"
    md="10"
    xl="7"
    class="mx-auto px-2 py-0 px-md-0"
    v-if="section"
  >
    <section class="content-main">
      <slot></slot>
    </section>
  </v-col>
  <v-col cols="12" lg="10" xl="7" class="mx-auto px-2 py-0 px-lg-0" v-else>
    <slot></slot>
  </v-col>
</template>

<script>
export default {
  name: "MyContainer",
  props: {
    section: Boolean
  }
};
</script>
